module.exports = __webpack_public_path__ + "img/logo.7ee18a6a.png";